import React, { Component } from "react"
import { Link } from "react-router"
import { Table } from "elemental"
import PropTypes from "prop-types"
import swal from "sweetalert"
import { translate } from "translate"
import { Button } from "elemental"
import _ from "lodash"
import shop from "shop/shop"
import moment from "moment"

import Price from "../components/Price/Price"

class AccountOrderDetailPage extends Component {
  constructor( props ) {
    super( props )

    this.state = {
      order:   {},
      orderId: props.params.orderId
    }
  }

  async componentDidMount() {
    const { orderId } = this.state
    const order = await this.getSelectedOrder( orderId )

    console.log( "order::get", order )

    this.setState( { order } )
  }

  render() {
    const { order } = this.state

    return (
      <div className="container mt4">
        <h1>
          <strong>Bestellung #{order.map_id}</strong>
        </h1>

        <h3 className="mt4">{translate( "cart.positions" )}</h3>
        <OrderDetailTable products={order.positions} netto={order.netto}/>
        <p>
          <span className="ttu b">{translate( "shop.comment" )}: </span>
          {order.comment ? order.comment : "-"}
        </p>

        <p>
          <span className="ttu b">Erstellt am: </span>
          {moment( order.created )
            .format( "DD-MM-YYYY" )}
        </p>

        <p className="mt4">
          <small>
            <Link to="/account">
            <Button>
              <i className="icon icon-angle-left"></i>
              Zurück zur Konto-Übersicht
            </Button>
            </Link>
          </small>
        </p>
      </div>
    )
  }

  getSelectedOrder( orderId ) {
    return shop.fetch( "data/orders?start=0&count=500&open=0" )
      .then( res => res.values )
      .then( orders => {
        let order = orders.filter( o => o.map_id == orderId )
        return _.first( order )
      } )
  }
}

const OrderDetailTable = ( { products, netto } ) => {
  return (
    <div className="table-scroller">
      <Table>
        <colgroup>
          <col width="10%"/>
          <col width="40%"/>
          <col width="20%"/>
          <col width="20%"/>
          <col width="10%"/>
          <col width="10%"/>
        </colgroup>

        <tbody>
        <tr>
          <th>{translate( "product.articlenr" )}</th>
          <th>{translate( "product.label" )}</th>
          <th className="tc">{translate( "product.amount" )}</th>
          <th className="tl">Stückpreis</th>
          <th className="tr">{translate( "product.price" )}</th>
          <th className="tr">&nbsp;</th>
        </tr>

        {products && products.map( ( product ) => <OrderDetailRow key={product.article_nr} product={product}/> )}

        <tr>
          <td className="tr" colSpan="6">
            <span className="ttu b">Summe:</span> {netto} EUR
          </td>
        </tr>
        </tbody>
      </Table>
    </div>
  )
}

OrderDetailTable.propTypes = {
  products: PropTypes.array,
}

const OrderDetailRow = ( { product } ) => {
  return (
    <tr>
      <td>{product.article_nr}</td>
      <td>{product.desc}</td>
      <td className="tc">{product.count}</td>
      <td className="tl"><Price>{product.price}</Price></td>
      <td className="tr"><Price>{product.sum}</Price></td>
      <td className="tr"><Button onClick={() => {
        shop.product( product.article_id ).then( newProduct => {
          console.log( "new", newProduct )
          if(!newProduct.price){
            return shop.toast("Produkt nicht mehr verfügbar", "info")
          }
          if ( newProduct.price === product.price ) {
            newProduct.count = 1
            shop.cart.add( newProduct )
            shop.toast(`${newProduct.desc.short_des} im Warenkorb`, "success")
          } else {
            swal( {
              text:              `Neuer Preis für ${newProduct.desc.short_des}`,
              title:             `${newProduct.price} €`,
              type:              "warning",
              showCancelButton:  true,
              animation:         false,
              confirmButtonText: "Hinzufügen",
              cancelButtonText:  "Zurück",
              closeOnConfirm:    true,
              html:              false
            }, () => {
              newProduct.count = 1
              shop.cart.add( newProduct )
            } )
          }

        } )
      }}><i className="icon icon-basket"/></Button></td>
    </tr>
  )
}

OrderDetailTable.propTypes = {
  product: PropTypes.object,
}

export default (AccountOrderDetailPage)



// WEBPACK FOOTER //
// ./src/pages/AccountOrderDetailPage.js